import { useContext, useEffect } from 'react';
import { TripDigestContext } from '@contexts/trip-digest-context';
import { useParams } from 'react-router-dom';
import { QuestionState } from '@generated/graphql';

interface TripProfileStateProps {
  fetchedStates: QuestionState[];
}

function TripProfileState({ fetchedStates }: TripProfileStateProps) {
  const { setQuestionState } = useContext(TripDigestContext)!;
  const { tripProfileId } = useParams();

  useEffect(() => {
    fetchedStates.forEach((item: QuestionState) => {
      // console.log('useEffect fetchedStates item: ', item);
      setQuestionState({
        id: item.id,
        tripProfileId: item.tripProfileId,
        questionId: item.questionId,
        parentQuestionId: item.parentQuestionId,
        questionType: item.questionType,
        rank: item.rank,
      });
    });
  }, [tripProfileId, fetchedStates, setQuestionState]);

  return null;
}

export default TripProfileState;
